const shouldSkip = ids => !ids || Array.isArray(ids) && !ids.length;
export default shouldSkip;
//# sourceMappingURL=shouldSkip.js.map